import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 22/23;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 23 22" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.414 2.432A1.097 1.097 0 018.966.882l3.286 3.288a1.095 1.095 0 010 1.549l-3.286 3.29a1.097 1.097 0 01-1.552-1.55l1.41-1.417h-1.14a4.934 4.934 0 00-4.93 4.93c0 2.558 2.295 4.932 4.381 4.932a1.095 1.095 0 110 2.192c-3.315 0-6.572-3.373-6.572-7.124a7.125 7.125 0 017.12-7.123h1.142l-1.41-1.417zm8.128 17.081a1.097 1.097 0 11-1.552 1.55l-3.288-3.288a1.095 1.095 0 010-1.55l3.288-3.288a1.095 1.095 0 111.55 1.55l-1.41 1.417h1.186a4.934 4.934 0 004.93-4.93c0-2.558-2.295-4.932-4.381-4.932a1.095 1.095 0 010-2.193c3.315 0 6.573 3.374 6.573 7.123a7.125 7.125 0 01-7.122 7.124H14.13l1.41 1.417h.002z" fill={color} fillRule="evenodd"/>
    </svg>
)

export default class IconRepeat extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
